import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize',
  standalone: true,
})
export class FileSizePipe implements PipeTransform {
  transform(bytes: number): string {
    if (bytes === 0) {
      return '0 Bytes';
    }

    const bytesPerUnit = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const unitIndex = Math.floor(Math.log(bytes) / Math.log(bytesPerUnit));
    const value =
      Math.round((bytes / Math.pow(bytesPerUnit, unitIndex)) * 100) / 100;
    const unit = unitIndex === 0 && value === 1 ? 'Byte' : sizes[unitIndex];

    return `${value} ${unit}`;
  }
}
